import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { createTeamTaskApi, getEmployeesApi } from "../../../../app/api";

export default function CreateTeamTaskDrawer({ team, open, onClose, onCreated }) {
  const [title,setTitle]=useState("");
  const [description,setDescription]=useState("");
  const [assignedTo,setAssignedTo]=useState([]);
  const [users,setUsers]=useState([]);
  const [loading,setLoading]=useState(false);

  useEffect(()=>{
    if(!open) return;
    getEmployeesApi().then(res=>setUsers(res.data||[]));
  },[open]);

  const handleSubmit=async()=>{
    setLoading(true);
    await createTeamTaskApi(team.id,{
      title,
      description,
      assigned_to: assignedTo
    });
    setLoading(false);
    onCreated();
    onClose();
    setTitle(""); setDescription(""); setAssignedTo([]);
  }

  return createPortal(
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-50 flex">
          <motion.div className="flex-1 bg-black/40" onClick={onClose} initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}/>
          <motion.div className="w-[500px] bg-white shadow-2xl flex flex-col" initial={{x:500}} animate={{x:0}} exit={{x:500}} transition={{type:"spring",stiffness:90,damping:20}}>
            <div className="flex justify-between items-center p-6 border-b">
              <h2 className="text-2xl font-bold">Create Task for {team.name}</h2>
              <button onClick={onClose}><XMarkIcon className="w-6 h-6"/></button>
            </div>
            <div className="flex-1 p-6 space-y-4">
              <div>
                <label>Title</label>
                <input value={title} onChange={e=>setTitle(e.target.value)} className="w-full border p-2 rounded"/>
              </div>
              <div>
                <label>Description</label>
                <textarea value={description} onChange={e=>setDescription(e.target.value)} className="w-full border p-2 rounded"/>
              </div>
              <div>
                <label>Assign To</label>
                <div className="max-h-40 overflow-y-auto border p-2 rounded space-y-1">
                  {users.map(u=>(
                    <label key={u.id} className="flex items-center gap-2">
                      <input type="checkbox" checked={assignedTo.includes(u.id)} onChange={()=>{
                        setAssignedTo(prev=> prev.includes(u.id)? prev.filter(x=>x!==u.id):[...prev,u.id])
                      }}/>
                      {u.first_name} {u.last_name}
                    </label>
                  ))}
                </div>
              </div>
              <div className="flex justify-end gap-2">
                <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
                <button onClick={handleSubmit} className="px-4 py-2 bg-indigo-600 text-white rounded">{loading?"Creating...":"Create Task"}</button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>,
    document.body
  );
}